import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Col, Form, Row } from "antd";
import styles from "./Login.module.css";
import authImg from "../../../assets/authImg.png";
import {
  Box,
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import google from "../../../assets/google.png";
import facebook from "../../../assets/facebook.png";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../config/roles";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
const Login = () => {
  const [email, setEmail] = useState();
  const [password, setpassword] = useState();
  const [passwordVisible, setpasswordVisible] = useState(true);
  const [role, setrole] = useState(roles.client);
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const onPressLogion = () => {
    console.log("Login");
    let userData = {
      email: email,
      password: password,
      role: role,
    };
    // dispatch(AuthMiddleware.login(userData));
    if (!email) {
      dispatch(
        showAlert({ type: "Error", message: "Email Field is Required!" })
      );
    } else if (!password) {
      dispatch(
        showAlert({ message: "Password Field is Required!", type: "Error" })
      );
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message:
            "Please enter a valid email address in the correct format (e.g: example@example.com)",
        })
      );
      return;
    } else if (!role) {
      dispatch(
        showAlert({
          message: "Please Select User Role!",
          type: "Error",
        })
      );
      return;
    } else {
      dispatch(AuthMiddleware.login(userData));
    }
  };

  const handleRolesChange = (value) => {
    // console.log(value);
    setrole(value.id);
  };

  //=====================social logins=============================
  const googleLogin = useGoogleLogin({
    onSuccess: async (respose) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${respose.access_token}`,
            },
          }
        );
        if (res) {
          // console.log("sdfsdfsdfsfdsdfsdf", res);
          dispatch(
            AuthMiddleware.Sociallogin({
              email: res?.data?.email,
              given_name: res?.data?.given_name,
              family_name: res?.data?.family_name,
              role: role,
            })
          );
        }
      } catch (err) {}
    },
    onError: (err) => {},
  });

  return (
    <div className={styles.mainCon}>
      <Row className={styles.subCon}>
        <Col className={styles.authImgCon}>
          <img src={authImg} className={styles.authImg} loading="lazy" />
        </Col>
        <Col className={styles.authContent}>
          <Box boxClass={styles.box}>
            <TextComponent text={"Welcome!"} textClass={styles.heading} />
            <TextComponent
              text={"Login to proceed"}
              textClass={styles.subHeading}
            />
            <div className={styles.inputs}>
              <InputField
                label="Email Address"
                placeholder={"email@bestdayever.com"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <InputField
                label={"Password"}
                placeholder={"••••••••••••••••"}
                value={password}
                onChange={(e) => setpassword(e.target.value)}
                rightIcon={
                  passwordVisible ? (
                    <BsEyeSlashFill color="var(--light-grey)" size={15} />
                  ) : (
                    <BsEyeFill color="var(--light-grey)" size={15} />
                  )
                }
                type={passwordVisible ? "password" : "text"}
                onRightIconPress={() => setpasswordVisible(!passwordVisible)}
              />
              <DropDown
                placeholder={"Select Role"}
                name={"role"}
                label={"Role"}
                // selectedValue={role}
                onChange={handleRolesChange}
                object={[
                  { id: roles.client, name: roles.client },
                  { id: roles.guest, name: roles.guest },
                  { id: roles.vendor, name: roles.vendor },
                  { id: roles.coHost, name: "Co Host" },
                  { id: roles.staff, name: roles.staff },
                ]}
              />
            </div>
            <SubmitButton title={"Log in"} onClick={onPressLogion} />
            <div className={styles.forgotDiv}>
              <div
                onClick={() => navigation("/forgotPassword")}
                className={styles.frgtText}
              >
                <TextComponent text={"Forgot Password?"} />
              </div>
              <TextComponent
                text={"Or Login with"}
                textClass={styles.loginText}
              />
              <div className={styles.social}>
                <img
                  src={google}
                  className={styles.socialImg}
                  onClick={() => {
                    if (!role) {
                      dispatch(
                        showAlert({
                          type: "error",
                          message: "Please select user role",
                        })
                      );
                    } else {
                      googleLogin();
                    }
                  }}
                />
                {/* <img src={facebook} className={styles.socialImg} /> */}
              </div>
              <div className={styles.accDiv}>
                <TextComponent
                  text={"Don't have an Account?"}
                  textClass={styles.accText}
                />
                <TextComponent
                  text={"SignUp"}
                  onClick={() => navigation("/selectrole")}
                  textClass={styles.signText}
                />
              </div>
            </div>
          </Box>
        </Col>
        {/* <Col className={styles.rightCol} >
          <div className={styles.loginFormCont}>
            <div style={{ width: '100%' }}>
            
                <InputField label='Email' placeholder={'email@bestdayever.com'} />
                <InputField
                    label={'Password'}
                    placeholder={'*************'}
                    value={password}
                    onChange={(e) => setpassword(e)}
                    rightIcon={passwordVisible ? <BsEyeFill color='var(--placeholder-text)' size={15}/> : <BsEyeSlashFill color='var(--placeholder-text)' size={15}/>}
                    onRightIconPress={() => setpasswordVisible(!passwordVisible)}
                    security={passwordVisible} />
                    <SubmitButton title={'Log in'}/>
            </div>
          </div>
          
        </Col> */}
      </Row>
    </div>
  );
};

export default Login;
